import { AllTableColumnsConfig, ClientConfig } from '@/__configs/config_types';
import { DeepPartial } from '@/redux/slices/slice_types';
import TitleHierarchy from '../components/TitleHierarchy';
import jobs from './columns/jobs';
import orders from './columns/orders';
import pendingAssets from './columns/pendingAssets';
import processingTasks from './columns/processingTasks';
import tasks from './columns/tasks';
import titles from './columns/titles';
import dashboardConfig from './dashboardConfig';
import dataConfig from './dataConfig';
import jobDetails from './jobDetails';
import orderPlacementConfig from './orderPlacementConfig';
import taskConfig from './taskConfig';
import theme from './theme';
import titleConfig from './titleConfig';
import viewingTitle from './viewingTitle';

const config: DeepPartial<ClientConfig> = {
  clientName: 'A+E',
  theme,
  viewingTitle,
  columns: { orders, jobs, processingTasks, tasks, titles, pendingAssets } as DeepPartial<AllTableColumnsConfig<unknown>>,
  jobDetails,
  dataConfig,
  taskConfig,
  titleConfig,
  dashboardConfig,
  orderPlacementConfig,
  ingestManagementConfig: {
    assetTypeValueMap: {
      Broadcast: 'BCM',
      International: 'IMF'
    },
    allowedUploadsBlurb: 'Select any MOV or MXF file(s) below.'
  },
  userColors: ['#aa6600', '#118833', '#dd3333', '#952a9f', '#cc4455', '#71a400', '#667799', '#bb44aa', '#8855ee', '#5566ee', '#4466ff', '#dd2277'],
  versionColors: {
    core: '#72A73C',
    nlm: '#EC5743',
    glb: '#B16BE9',
    bcm: '#5566ee'
  },
  enableUserDocumentation: true,
  disableJobDetailProxy: false,
  notifications: true,
  commonConstants: {
    fileTypeGrouping: {
      video: ['mov', 'mxf', 'mp4', 'avi', 'mpg', 'mpeg'],
      audio: ['wav', 'aac', 'mp3'],
      subtitle: ['srt', 'scc', 'vtt', 'webvtt', 'sub', 'ass', 'ssa', 'ttml', 'dfxp', 'itt', 'stl', 'tt', 'ttext', '_scc'],
      captions: [],
      image: ['jpg', 'jpeg', 'bmp', 'png', 'gif', 'svg', 'tiff', 'tif', 'psd'],
      other: ['pdf', 'prproj', 'xml', 'csv', 'xls', 'xlsx', 'txt', 'doc', 'docx', 'json']
    }
  },
  bulkActionIcons: {
    cancel_job: 'cancel',
    restart_job: 'refresh',
    retry_rally_job: 'reset'
  },
  userMenuOptions: {
    emailDomainSuffix: '@aegm.com',
    options: [
      {
        label: 'Ask ANDEE',
        icon: 'robot_outline',
        url: 'https://chatgpt.com/g/g-687824c119f081919e90e79dd0423f01-andee-2-5'
      }
    ]
  },
  filtersVersion: 2,
  titleHierarchyComponent: TitleHierarchy
};

export default config;
